// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"2afd6e48","92":"6aa5bada","138":"d3520bba","268":"b92526d6","326":"b3bb8d15","374":"a8a67dfe","453":"3517b05f","513":"cc2c840a","758":"8ff261d7","900":"de3ac1f8","966":"3330a47c"}[chunkId] + ".chunk.js";
};